import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import asyncAction from 'modules/core/lib/asyncAction'

import { useRoute } from 'modules/time_planning/lib/RouteContext'
import { trackAddNewPlanningVersionStart } from 'modules/time_planning/lib/trackEvents'
import { usePlanningVersions } from 'modules/time_planning/store/collections/planningVersions'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import CreateModal from './CreateModal'
import Item from './Item'
import * as styles from './index.vanilla.css'

export interface Props {
  employeeId: number
  selectedPlanningVersion: PlanningVersion
  left: number
  canEditPlanningVersions: boolean
}

const Items = ({ employeeId, selectedPlanningVersion, left, canEditPlanningVersions }: Props) => {
  const [createModalOpen, setCreateModalOpen] = React.useState(false)
  const planningVersions = usePlanningVersions()
  const sortedPlanningVersions = planningVersions.orderByEffectiveAt(employeeId)
  const navigate = useNavigate()
  const route = useRoute()

  function onDelete(planningVersion: PlanningVersion) {
    const previousVersion = planningVersions.getPrevious(employeeId, planningVersion)
    asyncAction(async () => {
      await planningVersion.destroy()

      if (planningVersion !== selectedPlanningVersion) return

      if (previousVersion) {
        navigate(route.planningVersions(String(previousVersion.id)))
      } else {
        navigate(route.index())
      }
    })
  }

  const onCreateNewPlanningVersion = () => {
    setCreateModalOpen(true)
    trackAddNewPlanningVersionStart('plus_button')
  }

  return (
    <>
      <ul
        className={styles.list}
        style={{
          left,
        }}
      >
        {sortedPlanningVersions.map((planningVersion: PlanningVersion, index: number) => (
          <li className={styles.item} key={planningVersion.attributes.id}>
            <Item
              key={index}
              employeeId={employeeId}
              canEditPlanningVersions={canEditPlanningVersions}
              planningVersion={planningVersion}
              active={planningVersion.attributes.id === selectedPlanningVersion.attributes.id}
              onClickDelete={() => onDelete(planningVersion)}
            />
          </li>
        ))}
        {canEditPlanningVersions && (
          <li className={styles.add} key="more" data-intercom-target="add-planning-version">
            <Button onClick={onCreateNewPlanningVersion} iconName="add" />
          </li>
        )}
      </ul>
      {createModalOpen && (
        <CreateModal employeeId={employeeId} onClose={() => setCreateModalOpen(false)} />
      )}
    </>
  )
}

export default observer(Items)
